import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { collection, onSnapshot } from "firebase/firestore";
import { firestore } from "../../firebase";
import { useAuth } from "../Context";

/**
 * Select de empleados por sucursal actual del contexto.
 * Props:
 *   value: id(s) del empleado seleccionado
 *   onChange: callback(idEmpleado)
 *   mode: "multiple" | undefined
 */
const EmpleadosSelect = ({ value, onChange, placeholder = "Selecciona empleado(s)", mode }) => {
  const { sucursal } = useAuth();
  const [empleados, setEmpleados] = useState([]);

  useEffect(() => {
    if (!sucursal) return;
    // Nueva estructura: empleado en raíz, filtrar por sucursal
    const q = collection(firestore, `empleado`);
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs
        .map(doc => ({
          id: doc.id,
          ...doc.data(),
        }))
        .filter(emp => emp.sucursal === sucursal); // Filtrar por sucursal
      setEmpleados(data);
    });
    return () => unsubscribe();
  }, [sucursal]);

  return (
    <Select
      showSearch
      allowClear
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      mode={mode}
      filterOption={(input, option) =>
        (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
      }
      style={{ width: "100%" }}
    >
      {empleados.map(empleado => (
        <Select.Option key={empleado.id} value={empleado.id}>
          {empleado.nombre || empleado.id}
        </Select.Option>
      ))}
    </Select>
  );
};

export default EmpleadosSelect;
